import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, resolveComponent as _resolveComponent, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, normalizeClass as _normalizeClass, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-5 d-flex flex-column text-center text-primary"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-save fa-7x me-2 animated slow flash infinite" }, null, -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "mt-1 big-text" }, [
  /*#__PURE__*/_createElementVNode("b", null, "Save Inquiry In Progress...")
], -1 /* HOISTED */)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]
const _hoisted_5 = {
  key: 1,
  class: "row p-2"
}
const _hoisted_6 = { class: "col-12 offset-lg-1 col-lg-5 row pe-3" }
const _hoisted_7 = { class: "form-group col-12 col-lg-4 pe-lg-2" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", { for: "contact-first-name" }, " Contact First Name ", -1 /* HOISTED */)
const _hoisted_9 = { class: "form-group col-12 col-lg-4 pe-lg-2" }
const _hoisted_10 = { for: "contact-middle-initial" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode(" M.I. ")
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { class: "form-group col-12 col-lg-4" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { for: "contact-last-name" }, " Contact Last Name ", -1 /* HOISTED */)
const _hoisted_15 = { class: "form-group col-12" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { for: "contact-phone-number" }, " Contact Phone Number", -1 /* HOISTED */)
const _hoisted_17 = { class: "form-group col-12" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", { for: "relationship-to-patient" }, " Relationship to Patient ", -1 /* HOISTED */)
const _hoisted_19 = { class: "form-group col-12" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("label", { for: "agency-location-id" }, [
  /*#__PURE__*/_createTextVNode(" Branch "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("option", { value: null }, "Select Branch", -1 /* HOISTED */)
const _hoisted_22 = ["label"]
const _hoisted_23 = ["value"]
const _hoisted_24 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_25 = {
  key: 0,
  class: "form-group col-12"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", {
  for: "agency-location-id",
  id: "hospice-service-requested"
}, " Services Requested ", -1 /* HOISTED */)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "flex-shrink-1 flex-grow-1" }, [
  /*#__PURE__*/_createElementVNode("input", {
    class: "form-control",
    name: "service-requested",
    type: "text",
    value: "Hospice",
    disabled: true
  })
], -1 /* HOISTED */)
const _hoisted_28 = [
  _hoisted_26,
  _hoisted_27
]
const _hoisted_29 = { class: "form-group col-12" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("label", { for: "teamMember" }, " Assign Team Member to Follow Up ", -1 /* HOISTED */)
const _hoisted_31 = { class: "form-group col-6" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("label", {
  for: "date",
  class: "d-inline-block"
}, " Inquiry Date ", -1 /* HOISTED */)
const _hoisted_33 = { class: "input-group date datepickerInput" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_35 = { class: "form-group col-6 ps-lg-2" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", {
  for: "followUpDate",
  class: "d-inline-block"
}, " Follow-Up Date ", -1 /* HOISTED */)
const _hoisted_37 = { class: "input-group date datepickerInput" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "input-group-addon input-group-append" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "input-group-text" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-calendar" })
  ])
], -1 /* HOISTED */)
const _hoisted_39 = { class: "col-12 col-lg-5 row ps-3" }
const _hoisted_40 = { class: "form-group col-12 col-lg-4 pe-lg-2" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("label", { for: "patient-first-name" }, [
  /*#__PURE__*/_createTextVNode(" Patient First Name "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_42 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_43 = { class: "form-group col-12 col-lg-4 pe-lg-2" }
const _hoisted_44 = { for: "patient-middle-initial" }
const _hoisted_45 = ["maxlength", "placeholder"]
const _hoisted_46 = { class: "form-group col-12 col-lg-4 pe-lg-2" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("label", { for: "patient-last-name" }, [
  /*#__PURE__*/_createTextVNode(" Patient Last Name "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_48 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_49 = { class: "form-group col-12" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("label", { for: "phone-number" }, [
  /*#__PURE__*/_createTextVNode(" Patient Phone Number "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1 /* HOISTED */)
const _hoisted_51 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_52 = {
  key: 0,
  class: "field-invalid"
}
const _hoisted_53 = {
  key: 1,
  class: "field-invalid"
}
const _hoisted_54 = { class: "form-group col-12" }
const _hoisted_55 = /*#__PURE__*/_createElementVNode("label", { for: "patient-current-location" }, " Patient Current Location ", -1 /* HOISTED */)
const _hoisted_56 = { class: "form-group col-12" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("label", { for: "inquiry-comments" }, " Comments ", -1 /* HOISTED */)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PhoneNumber = _resolveComponent("PhoneNumber")!
  const _component_TypeaheadInput = _resolveComponent("TypeaheadInput")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_CommentInput = _resolveComponent("CommentInput")!
  const _component_FormSection = _resolveComponent("FormSection")!
  const _directive_tooltip = _resolveDirective("tooltip")!
  const _directive_number_only = _resolveDirective("number-only")!

  return (_openBlock(), _createBlock(_component_FormSection, {
    fullHeight: false,
    applicationId: _ctx.inquiry.application
  }, {
    content: _withCtx(() => [
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("section", _hoisted_1, _hoisted_4))
        : _createCommentVNode("v-if", true),
      (!_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("section", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _hoisted_8,
                _withDirectives(_createElementVNode("input", {
                  class: "form-control",
                  maxlength: "50",
                  name: "contact-first-name",
                  type: "text",
                  placeholder: "Enter Contact First Name",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inquiry.contactFirstName) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, _ctx.inquiry.contactFirstName]
                ])
              ]),
              _createElementVNode("div", _hoisted_9, [
                _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_10, _hoisted_12)), [
                  [_directive_tooltip, { title: 'Middle Initial' }]
                ]),
                _withDirectives(_createElementVNode("input", {
                  class: "form-control",
                  maxlength: 1,
                  name: "contact-middle-initial",
                  type: "text",
                  placeholder: "Enter M.I.",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.inquiry.contactMiddleInitial) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, _ctx.inquiry.contactMiddleInitial]
                ])
              ]),
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _withDirectives(_createElementVNode("input", {
                  class: "form-control",
                  maxlength: "50",
                  name: "contact-last-name",
                  type: "text",
                  placeholder: "Enter Contact Last Name",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.inquiry.contactLastName) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, _ctx.inquiry.contactLastName]
                ])
              ]),
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                (_ctx.inquiry.contactPhoneNumbers?.length > 0)
                  ? _withDirectives((_openBlock(), _createBlock(_component_PhoneNumber, {
                      key: 0,
                      name: `contactPhoneNumbers`,
                      enableCountry: true,
                      value: _ctx.inquiry.contactPhoneNumbers[0].number,
                      "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.inquiry.contactPhoneNumbers[0].number) = $event)),
                      country: _ctx.inquiry.contactPhoneNumbers[0].country,
                      "onUpdate:country": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.inquiry.contactPhoneNumbers[0].country) = $event)),
                      extension: _ctx.inquiry.contactPhoneNumbers[0].extension,
                      "onUpdate:extension": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.inquiry.contactPhoneNumbers[0].extension) = $event)),
                      type: _ctx.inquiry.contactPhoneNumbers[0].type,
                      "onUpdate:type": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.inquiry.contactPhoneNumbers[0].type) = $event))
                    }, null, 8 /* PROPS */, ["value", "country", "extension", "type"])), [
                      [_directive_number_only]
                    ])
                  : _createCommentVNode("v-if", true)
              ]),
              _createElementVNode("div", _hoisted_17, [
                _hoisted_18,
                _withDirectives(_createElementVNode("input", {
                  class: "form-control",
                  maxlength: "50",
                  name: "contact-relationship-to-patient",
                  type: "text",
                  placeholder: "Enter Relationship",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.inquiry.contactRelationshipToPatient) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, _ctx.inquiry.contactRelationshipToPatient]
                ])
              ]),
              _createElementVNode("div", _hoisted_19, [
                _hoisted_20,
                _withDirectives(_createElementVNode("select", {
                  class: _normalizeClass(["form-select", `${!_ctx.v$.inquiry.locationId.$error ? '' : 'field-invalid'}`]),
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.inquiry.locationId) = $event)),
                  onChange: _cache[9] || (_cache[9] = ($event: any) => (_ctx.selectedBranch(_ctx.inquiry.locationId))),
                  onBlur: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.v$.inquiry.locationId.$touch && _ctx.v$.inquiry.locationId.$touch(...args)))
                }, [
                  _hoisted_21,
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.branches, (branch) => {
                    return (_openBlock(), _createElementBlock("optgroup", {
                      label: branch.providerName,
                      key: branch.id
                    }, [
                      _createElementVNode("option", {
                        value: branch.id
                      }, _toDisplayString(branch.name), 9 /* TEXT, PROPS */, _hoisted_23)
                    ], 8 /* PROPS */, _hoisted_22))
                  }), 128 /* KEYED_FRAGMENT */))
                ], 34 /* CLASS, HYDRATE_EVENTS */), [
                  [_vModelSelect, _ctx.inquiry.locationId]
                ]),
                (_ctx.v$.inquiry.locationId.$error)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_24, "Branch is required."))
                  : _createCommentVNode("v-if", true)
              ]),
              (_ctx.inquiry.application === _ctx.ApplicationEnum.AxxessHospiceFE)
                ? (_openBlock(), _createElementBlock("div", _hoisted_25, _hoisted_28))
                : _createCommentVNode("v-if", true),
              _createElementVNode("div", _hoisted_29, [
                _hoisted_30,
                _createVNode(_component_TypeaheadInput, {
                  getData: _ctx.getTeamList,
                  value: _ctx.teamMember,
                  onValueChanged: _ctx.changeTeamMember,
                  placeholder: "Search Team Member",
                  openOnFocus: _ctx.openOnFocus,
                  changeOpenOnFocus: _ctx.changeOpenOnFocus
                }, null, 8 /* PROPS */, ["getData", "value", "onValueChanged", "openOnFocus", "changeOpenOnFocus"])
              ]),
              _createElementVNode("div", _hoisted_31, [
                _hoisted_32,
                _createVNode(_component_DatePicker, { getDate: _ctx.changeDate }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_33, [
                      _withDirectives(_createElementVNode("input", {
                        name: "date",
                        type: "text",
                        class: "form-control",
                        placeholder: "MM/DD/YYYY",
                        autocomplete: "off",
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.inquiry.date) = $event))
                      }, null, 512 /* NEED_PATCH */), [
                        [_vModelText, _ctx.inquiry.date]
                      ]),
                      _hoisted_34
                    ])
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["getDate"])
              ]),
              _createElementVNode("div", _hoisted_35, [
                _hoisted_36,
                _createVNode(_component_DatePicker, { getDate: _ctx.changeDate }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_37, [
                      _withDirectives(_createElementVNode("input", {
                        name: "followUpDate",
                        type: "text",
                        class: "form-control",
                        placeholder: "MM/DD/YYYY",
                        autocomplete: "off",
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.inquiry.followUpDate) = $event))
                      }, null, 512 /* NEED_PATCH */), [
                        [_vModelText, _ctx.inquiry.followUpDate]
                      ]),
                      _hoisted_38
                    ])
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["getDate"])
              ])
            ]),
            _createElementVNode("div", _hoisted_39, [
              _createElementVNode("div", _hoisted_40, [
                _hoisted_41,
                _withDirectives(_createElementVNode("input", {
                  class: _normalizeClass(["form-control", `${!_ctx.v$.inquiry.firstName.$error ? '' : 'field-invalid'}`]),
                  maxlength: "50",
                  name: "patient-first-name",
                  type: "text",
                  placeholder: "Enter Patient First Name",
                  "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.inquiry.firstName) = $event)),
                  onBlur: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.v$.inquiry.firstName.$touch && _ctx.v$.inquiry.firstName.$touch(...args)))
                }, null, 34 /* CLASS, HYDRATE_EVENTS */), [
                  [_vModelText, _ctx.inquiry.firstName]
                ]),
                (_ctx.v$.inquiry.firstName.$error)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_42, "First Name is required."))
                  : _createCommentVNode("v-if", true)
              ]),
              _createElementVNode("div", _hoisted_43, [
                _withDirectives((_openBlock(), _createElementBlock("label", _hoisted_44, [
                  _createTextVNode(_toDisplayString(_ctx.middleNameLabel), 1 /* TEXT */)
                ])), [
                  [_directive_tooltip, !_ctx.isApplicationPalliative ? { title: 'Middle Initial' } : null]
                ]),
                _withDirectives(_createElementVNode("input", {
                  class: "form-control",
                  maxlength: _ctx.isApplicationPalliative ? 100 : 1,
                  name: "patient-middle-initial",
                  type: "text",
                  placeholder: _ctx.isApplicationPalliative ? 'Enter Middle Name' : 'Enter M.I.',
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.inquiry.middleName) = $event))
                }, null, 8 /* PROPS */, _hoisted_45), [
                  [_vModelText, _ctx.inquiry.middleName]
                ])
              ]),
              _createElementVNode("div", _hoisted_46, [
                _hoisted_47,
                _withDirectives(_createElementVNode("input", {
                  class: _normalizeClass(["form-control", `${!_ctx.v$.inquiry.lastName.$error ? '' : 'field-invalid'}`]),
                  maxlength: "50",
                  name: "patient-last-name",
                  type: "text",
                  placeholder: "Enter Patient Last Name",
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.inquiry.lastName) = $event)),
                  onBlur: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => (_ctx.v$.inquiry.lastName.$touch && _ctx.v$.inquiry.lastName.$touch(...args)))
                }, null, 34 /* CLASS, HYDRATE_EVENTS */), [
                  [_vModelText, _ctx.inquiry.lastName]
                ]),
                (_ctx.v$.inquiry.lastName.$error)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_48, "Last Name is required."))
                  : _createCommentVNode("v-if", true)
              ]),
              _createElementVNode("div", _hoisted_49, [
                _hoisted_50,
                _withDirectives(_createVNode(_component_PhoneNumber, {
                  name: `phoneNumbers`,
                  enableCountry: true,
                  value: _ctx.inquiry.phoneNumbers[0].number,
                  "onUpdate:value": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.inquiry.phoneNumbers[0].number) = $event)),
                  country: _ctx.inquiry.phoneNumbers[0].country,
                  "onUpdate:country": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.inquiry.phoneNumbers[0].country) = $event)),
                  extension: _ctx.inquiry.phoneNumbers[0].extension,
                  "onUpdate:extension": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.inquiry.phoneNumbers[0].extension) = $event)),
                  type: _ctx.inquiry.phoneNumbers[0].type,
                  "onUpdate:type": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.inquiry.phoneNumbers[0].type) = $event)),
                  onBlurredInput: _ctx.v$.inquiry.phoneNumbers[0].number.$touch,
                  class: _normalizeClass(`${!_ctx.v$.inquiry.phoneNumbers[0].number.$error ? '' : 'field-invalid'}`)
                }, null, 8 /* PROPS */, ["value", "country", "extension", "type", "onBlurredInput", "class"]), [
                  [_directive_number_only]
                ]),
                (_ctx.v$.inquiry.phoneNumbers[0].number.$error)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_51, [
                      (_ctx.v$.inquiry.phoneNumbers[0].number.$errors[0].$message == 'Value is required')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_52, "Phone number is required."))
                        : (_openBlock(), _createElementBlock("span", _hoisted_53, "10 Digit phone is required."))
                    ]))
                  : _createCommentVNode("v-if", true)
              ]),
              _createElementVNode("div", _hoisted_54, [
                _hoisted_55,
                _withDirectives(_createElementVNode("input", {
                  class: "form-control",
                  maxlength: "100",
                  name: "patient-current-location",
                  type: "text",
                  placeholder: "Enter Patient Current Location",
                  "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.inquiry.currentLocation) = $event))
                }, null, 512 /* NEED_PATCH */), [
                  [_vModelText, _ctx.inquiry.currentLocation]
                ])
              ]),
              _createElementVNode("div", _hoisted_56, [
                _hoisted_57,
                _createVNode(_component_CommentInput, {
                  "input-name": "inquiry-comments",
                  placeholder: "Enter Comments",
                  result: _ctx.inquiry.comment,
                  onResultUpdatedAppended: _ctx.resultUpdatedAppended,
                  onResultUpdated: _ctx.resultUpdated,
                  application: _ctx.inquiry.application
                }, null, 8 /* PROPS */, ["result", "onResultUpdatedAppended", "onResultUpdated", "application"])
              ])
            ])
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["applicationId"]))
}